module.exports = __webpack_public_path__ + "static/media/badge_yuyan.d4a100b9.svg";